<template>
    <!-- 商品搜索框 -->
    <div class="filterBox">
        <div class="ul ul-first">
            <div :class="`item distance ${sort_type === 0 ? 'distance-on' : ''}`" @click="onChangeDistance">距离最近</div>
            <div class="item price" @click="onChangePrice">
                <span>价格</span>
                <ArrowsChange style="margin-top: 14px" :num="price" />
            </div>
            <div class="item tagFilter" @click="onShowTagFilter">
                <span class="text">标签筛选</span>
                <van-icon :name="filterTagsShow ? 'arrow-up' : 'arrow-down'" />
            </div>
        </div>
        <div class="ul">
            <div :class="{'is-btn':true, 'is-btn-on': is_vip === 1}" @click="onChangeVip">渠道专享</div>
            <div :class="{'is-btn':true, 'is-btn-on': is_nearby === 1}" @click="onChangeNearby">附近20km</div>
        </div>
        <!-- 筛选标签 -->
        <FilterTags
            :tagsData="tagsData"
            :defaultTagsData="defaultTagsData"
            ref="FilterTags"
            @filterTagsShow="getFilterTagsShow"
            @onFilterTagsChange="onFilterTagsChange"
        />
    </div>
</template>

<script>
import ArrowsChange from '@/components/arrowsChange/arrowsChange'
import FilterTags from './filterTags.vue'

export default {
    name: 'filterBox',
    props: {
        placeholder: {
            type: String,
            default: '请输入内容'
        },
        hasSearch: {
            type: Boolean,
            default: false
        },
        tagsData:{
            type: Array,
            default () {
                return []
            }
        },
    },
    components: {
        ArrowsChange,
        FilterTags
    },
    data () {
        return {
            defaultTagsData: [], // 默认选中数据
            filterTagsShow: false,
            is_vip: 0, // 是否渠道专享
            is_nearby: 0, // 是否附近20km
            // distance: 0, // 距离最近排序
            price: '', // 用来展示价格的 icon 显示状态
            sort_type: 0, // 排序规则
            tags: '', // 筛选标签id
        }
    },
    watch:{
        sort_type (n) {
            if (n === 2) {
                this.price = 0
            } else if (n === 3) {
                this.price = 1
            } else {
                this.price = ''
            }
        }
    },
    mounted () {
        /* 回调一次默认参数给父组件, 第一次传默认参数的时候，不触发请求 */
        this.onParamsCallBack(true)
    },
    methods: {
        /**
         * 获取筛选标签弹窗是否显示隐藏
         * @params {_flag} Boolean
         */
        getFilterTagsShow (_flag) {
            this.filterTagsShow = _flag
        },
        /**
         * 回调给父组件的参数数据
         */
        onParamsCallBack (isDefaultParams = false) {
            const obj = {
                is_vip: this.is_vip,
                is_nearby: this.is_nearby,
                sort_type: this.sort_type,
                tags: this.tags
            }
            this.$emit('onParamsCallBack', obj, isDefaultParams)
        },
        /**
         * 显示筛选标签
         */
        onShowTagFilter () {
            this.$refs.FilterTags.display(!this.filterTagsShow)
        },
        /**
         * 筛选tags改变
         */
        onFilterTagsChange (_arr) {
            this.tags = _arr.join(',')
            this.defaultTagsData = _arr
            this.onParamsCallBack()
        },
        /**
         * 是否渠道专享
         */
        onChangeVip () {
            this.is_vip = Number(!this.is_vip)
            this.$refs.FilterTags.display(false)
            this.onParamsCallBack()
        },
        /**
         * 是否附近20km
         */
        onChangeNearby () {
            this.is_nearby = Number(!this.is_nearby)
            this.$refs.FilterTags.display(false)
            this.onParamsCallBack()
        },
        /**
         * 切换距离排序
         */
        onChangeDistance () {
            if (this.sort_type === 0) {
                this.sort_type = ''
            } else {
                this.sort_type = 0
            }
            this.$refs.FilterTags.display(false)
            this.onParamsCallBack()
        },
        /**
         * 切换价格排序
         */
        onChangePrice () {
            if (this.sort_type === 0 || this.sort_type === 3) {
                this.sort_type = 2
            } else {
                this.sort_type = 3
            }
            this.$refs.FilterTags.display(false)
            this.onParamsCallBack()
        },
    }
}
</script>

<style lang="stylus" scoped>
@import '../../../assets/stylus/variables'
.filterBox
    background #ffffff
    position relative
    z-index 100
    .ul
        border-top 1px solid #efefef
        padding 0 30px
        height 80px
        line-height 80px
        .item
            font-size 26px
            // line-height 32px
            color #666666
            vertical-align top
        .price
            span
                margin-right 10px
                vertical-align top
        .tagFilter
            .text
                margin-right 10px
        .is-btn
            display inline-block
            height 48px
            line-height 48px
            padding 0 22px
            text-align center
            border-radius 22px
            background #eeeeee
            border 1px solid #eeeeee
            color #666666
            font-size 24px
            margin-right 50px
        .is-btn-on
            color #fc2d2d
            background #ffdede
            border 1px solid #fc2d2d
            color #fc2d2d
        .distance-on
            color #fc2d2d
    .ul-first
        display flex
        justify-content space-between
        align-items center

</style>
